import { Direction, getEnumOptions, ProtectionPlusOptions, ReportName, SeverityType } from '@src/utils/enums';

export interface ReportMetadataAndData {
    metadata: {
        isLoading: boolean;
        hasError: boolean;
    }
    data: any[] | undefined;
}

// Internal enum for filter keys
export enum FilterKey {
    direction = 'direction',
    action = 'action',
    severity = 'severity',
    showUSA = 'showUSA'
}

export const FilterOptions = {
    [FilterKey.direction]: getEnumOptions(Direction),
    [FilterKey.action]: getEnumOptions(ProtectionPlusOptions),
    [FilterKey.severity]: [{ value: '', label: 'All' }, ...getEnumOptions(SeverityType)],
};

// Mapping of reports to the filters they support
export const reportFilters: Partial<Record<ReportName, FilterKey[]>> = {
    [ReportName.TOP_15_BLOCKED_APPS]: [FilterKey.direction],
    [ReportName.TOP_15_BLOCKED_SERVICES]: [FilterKey.direction],
    [ReportName.TOP_15_BLOCKED_COUNTRIES]: [FilterKey.direction],
    [ReportName.TOP_15_ALLOWED_COUNTRIES]: [FilterKey.showUSA, FilterKey.direction],
    [ReportName.TOP_15_DETECTED_THREATS]: [FilterKey.action, FilterKey.severity],
};

// mapping of FilterKey to display names
export const FilterKeyDisplayNames: Record<FilterKey, string> = {
    [FilterKey.direction]: FilterKey.direction,
    [FilterKey.action]: FilterKey.action,
    [FilterKey.severity]: FilterKey.severity,
    [FilterKey.showUSA]: 'Show USA'
};
